import { createContext, ReactNode, useContext, useState } from 'react';

const ProjectListsContext = createContext<{
    version: number;
    refresh: () => void;
}>({
    version: 0,
    refresh: () => null,
});

const ProjectListsProvider = ({ children }: { children: ReactNode }) => {
    const [version, setVersion] = useState(0);

    return (
        <ProjectListsContext.Provider value={{ version, refresh: () => setVersion((current) => current + 1) }}>
            {children}
        </ProjectListsContext.Provider>
    );
};

const useProjectListsContext = () => useContext(ProjectListsContext);

export { ProjectListsProvider, useProjectListsContext };
